import TranslationUtils from '@gik/core/utils/TranslationUtils';

const blockName = 'not-found';

const translations = {
  title: 'HTTP ERROR 404',
  subTitle: '(NOT FOUND)',
  description:
    "Sorry, we couldn't find what you were looking for. Sad face :(. Make a selection in the navigation above, the footer on the bottom, or browse product categories below:",
  searchPlaceholder: 'Search pages, products & articles',
};

export default {
  [blockName]: translations,
};

export const translationKeys: typeof translations = TranslationUtils.mapKeys(blockName, translations);
